<template>
    <el-form :rules="rules" class="login-container" label-position="left" label-width="0px" v-loading="loading">
        <h3 class="login_title">系统登录</h3>
        <el-form-item prop="account">
            <el-input type="text" v-model="loginForm.username" auto-complete="off" placeholder="账号"></el-input>
        </el-form-item>
        <el-form-item prop="checkPass">
            <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item style="width: 100%">
            <el-button type="primary" @click.native.prevent="submitClick" style="width: 100%">登录</el-button>
        </el-form-item>
    </el-form>
</template>
<script>
import { loginAccount } from '@/api';
export default {
    data() {
        return {
            rules: {
                account: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }],
            },
            checked: true,
            loginForm: {
                username: '',
                password: '',
            },
            loading: false,
        };
    },
    methods: {
        async submitClick() {
            this.loading = true;
            try {
                const { data, status } = await loginAccount({ ...this.loginForm });
                if (status === 200 && data.status === 'success') {
                    this.$message({ type: 'success', message: '登陆成功' });
                    this.$router.replace({ path: '/home' });
                } else {
                    this.$message({ type: 'error', message: data.msg });
                }
                this.loading = false;
            } catch (error) {}
        },
    },
};
</script>
<style>
.login-container {
    border-radius: 15px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
}

.login_title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
}

.login_remember {
    margin: 0px 0px 35px 0px;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue